import { render, staticRenderFns } from "./romaKingdom.vue?vue&type=template&id=6b339b9c&scoped=true"
import script from "./romaKingdom.vue?vue&type=script&lang=js"
export * from "./romaKingdom.vue?vue&type=script&lang=js"
import style0 from "./romaKingdom.vue?vue&type=style&index=0&id=6b339b9c&prod&scoped=true&lang=css"
import style1 from "./romaKingdom.vue?vue&type=style&index=1&id=6b339b9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b339b9c",
  null
  
)

export default component.exports